<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <search-form key="formUserSearch"
                     :inputs="searchInputsEx"
                     class="mb-5"
                     @clear="handleClearClick"
                     @search="handleSearchClick" />
        <hr />
        <div class="row">
            <div class="col">
                <page-size v-model="pageSize"
                           @input="handleSearchClick(searchPayload)" />
            </div>
            <div class="col">
                <order-by v-model="selectedOrderBy"
                          :options="orderByOptions"
                          @goClick="handleOrderByClick" />
            </div>
        </div>
        <data-list :dataCols="repairMatrixCols"
                   :dataListItems="repairMatrixList"
                   :tableClass="'table table-striped table-sm'" />

        <b-pagination align="center"
                      size="md"
                      :total-rows="totalRecords"
                      v-model="pageNumber"
                      :per-page="pageSize"
                      @input="handlePagenationInput" />

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>

    import OrderBy from '@/components/OrderBy.vue'
    import PageHeader from '@/components/PageHeader.vue'
    import DataList from '@/components/DataList.vue'
    //import DataListCSV from '@/components/DataListCSV.vue'


    import PageSize from '@/components/PageSize.vue'
    import SearchForm from '@/components/SearchForm.vue'

    import { searchInputs } from '@/ui.config/inputs/repairOptionSearchInputs'
    import { repairMatrixCols } from '@/ui.config/cols/repairMatrixCols'

    import { mapActions } from 'vuex'

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: 'RepairOptions',
        mixins: [

        ],
        components: {
            PageHeader,
            DataList,
            //'data-list-csv': DataListCSV,
            PageSize,
            SearchForm,
            Loading,
            OrderBy
        },
        data: () => {
            return {
                pageHeader: {
                    title: 'Repair Options - Matrix',
                },

                searchInputs: searchInputs,
                repairMatrixCols: repairMatrixCols,

                searchPayload: null,
                //pageSize: 5,
                orderBy: 'DateCreated',
                sortDirection: 'DESC',

                selectedOrderBy: null,

                // Override mixin
                orderByOptions: [
                    {
                        id: 0,
                        key: 'DeviceTypeLabel',
                        label: 'Device Type'
                    },
                    {
                        id: 1,
                        key: 'RepairProviderLabel',
                        label: 'Repair Provider'
                    },
                    {
                        id: 2,
                        key: 'RepairOptionTypeLabel',
                        label: 'Repair Option Type'
                    }
                ],
            }
        },
        beforeMount() {
            this.fetchRepairOptionMatrix({})
            this.fetchIncidentTypes()
            this.fetchRepairProviders()
            this.fetchRepairOptionTypes()
            this.fetchDeviceTypes()
            this.fetchDeviceMakes()
        },
        computed: {
            isLoading() {
                return this.$store.getters.isLoading
            },
            pageNumber: {
                get() {
                    return this.$store.getters.pageNumber
                },
                set(value) {
                    this.$store.commit('setPageNumber', value)
                }
            },
            totalRecords() {
                return this.$store.getters.totalRecords
            },
            pageSize: {
                get() {
                    return this.$store.getters.pageSize
                },
                set(value) {
                    this.$store.commit('setPageSize', value)
                }
            },
            repairMatrixList() {
                return this.$store.getters.repairOptionMatrix
            },
            deviceTypes() {
                return this.$store.getters.deviceTypes
            },
            deviceMakes() {
                return this.$store.getters.deviceMakes
            },
            incidentTypes() {
                return this.$store.getters.incidentTypesDisplayLabel1
            },
            repairProviders() {
                return this.$store.getters.repairProviders
            },
            repairOptionTypes() {
                return this.$store.getters.repairOptionTypes
            },
            searchInputsEx() {
                var { searchInputs, deviceTypes, deviceMakes, incidentTypes, repairProviders, repairOptionTypes } = this

                if (searchInputs && searchInputs.length > 0) {
                    if (deviceTypes) {
                        searchInputs[0].options = deviceTypes
                    }

                    if (deviceMakes) {
                        searchInputs[1].options = deviceMakes
                    }

                    if (incidentTypes) {
                        searchInputs[3].options = incidentTypes
                    }

                    if (repairProviders) {
                        searchInputs[4].options = repairProviders
                    }

                    if (repairOptionTypes) {
                        searchInputs[5].options = repairOptionTypes
                    }

                    searchInputs[6].options = [{ id: 1, label: 'YES' }, {id: 0, label:'NO'}]
                }

                return searchInputs
            },
            resellers() {
                return this.$store.getters.resellers
            },
        },
        methods: {
            ...mapActions([
                'fetchRepairOptionMatrix',
                'fetchIncidentTypes',
                'fetchRepairProviders',
                'fetchRepairOptionTypes',
                'fetchDeviceTypes',
                'fetchDeviceMakes'
            ]),
            handlePagenationInput(payload) {
                let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))
                this.search(criteria, payload)
            },
            handleOrderByClick(payload) {
                let { orderBy, direction } = payload
                if ((typeof (orderBy) != 'undefined' && orderBy != null) &&
                    (typeof (orderBy) != 'undefined' && orderBy != null)) {

                    this.orderBy = orderBy.key
                    this.sortDirection = direction
                    this.handleSearchClick(this.searchPayload)
                }
            },
            handleSearchClick(payload) {
                if (payload != null) {
                    this.searchPayload = payload

                    let criteria = this.buildSearchValues(payload)

                    this.search(criteria, 1)
                } else {
                    this.search(null, 1)
                }
            },
            handleClearClick() {

                this.claimsSearch(null, 1)
            },
            buildSearchValues(payload) {
                if (payload != null) {
                    let { deviceType, make, model, incidentType, provider, optionType, includeDisabled } = payload

                    let criteria = {
                        deviceTypeId: deviceType ? deviceType.id : null,
                        makeId: make ? make.id : null,
                        incidentTypeId: incidentType ? incidentType.id : null,
                        repairProviderId: provider ? provider.id : null,
                        repairOptionTypeId: optionType ? optionType.id : null,
                        includeDisabled: includeDisabled ? includeDisabled.id : null,
                        modelFreeText: model
                    }

                    return criteria
                } else {
                    return null
                }
            },
            buildSearchCriteria(searchValues, pageNumber) {
                let ordering = {
                    orderBy: this.orderBy,
                    sortDirection: this.sortDirection
                }

                let pages = {
                    pageSize: this.pageSize,
                    pageNumber: pageNumber
                }

                let criteria = {
                    ...searchValues,
                    ...ordering,
                    ...pages
                }

                return criteria
            },
            search(searchValues, pageNumber) {
                
                let criteria = this.buildSearchCriteria(searchValues, pageNumber)

                this.fetchRepairOptionMatrix(criteria)
            }
        }
    }
</script>

<style>
</style>
